module.exports = __webpack_public_path__ + "static/media/shop-template.a6276115.png";